import { ActionType } from '../../types';

export const SiteActions = {
    SiteRegistrationStarted: () =>
    ({
        type: 'Site/Registration/Started',
    } as const),

    SiteRegistrationSucceeded: (id: string, name: string) =>
    ({
        type: 'Site/Registration/Succeeded',
        payload: { id, name },
    } as const),

    SiteRegistrationFailed: () =>
    ({
        type: 'Site/Registration/Failed',
    } as const),

    SiteRegistrationReset: () =>
    ({
        type: 'Site/Registration/Reset',
    } as const),

    SiteDeleteStarted: () =>
    ({
        type: 'Site/Delete/Started',
    } as const),

    SiteDeleteSucceeded: () =>
    ({
        type: 'Site/Delete/Succeeded',
        payload: {},
    } as const),

    SiteDeleteFailed: (errorCode: string) =>
    ({
        type: 'Site/Delete/Failed',
        payload: { errorCode },
    } as const),

    SiteDeleteReset: () =>
    ({
        type: 'Site/Delete/Reset',
    } as const),

    SiteUpdateStarted: () =>
    ({
        type: 'Site/Update/Started',
    } as const),

    SiteUpdateSucceeded: () =>
    ({
        type: 'Site/Update/Succeeded',
        payload: {},
    } as const),

    SiteUpdateFailed: () =>
    ({
        type: 'Site/Update/Failed',
    } as const),
    SiteUpdateReset: () =>
    ({
        type: 'Site/Update/Reset',
    } as const),

    ExludeStateSucceeded: (data: {}, country: string, state: string) =>
    ({
        type: 'Site/ExcludeStates/Succeeded',
        payload: { data, country, state },
    } as const),

};

export type SiteActions = ActionType<typeof SiteActions>;
